module.exports = __webpack_public_path__ + "img/Shiba-BG.e7fdde4b.jpg";